// import appAndPages from './app-and-pages'
// import chartsAndMaps from './charts-and-maps'
// import dashboard from './dashboard'
// import formsAndTables from './forms-and-tables'
// import others from './others'
// import uiElements from './ui-elements'
import views from './views'

// Array of sections
// export default [...dashboard, ...views, ...appAndPages, ...uiElements, ...formsAndTables, ...chartsAndMaps, ...others]

export default [...views]
